import { css } from "styled-components";

export const getCarrot = css`
  div[id^="carrot-messenger-collapsed-frame"] {
    display: none !important;
  }
`;
